import Styles from 'src/components/Styles';
import AVText from 'src/components/elements/AVText';
import DealDetailIcon from 'src/components/img/svg/DealIconDetail';
import {DealDescriberData} from 'src/components/screens/inbox/descriptor/DescriptorType';
import RoundedButton, {ButtonType} from 'src/components/elements/RoundedButton';
import Localized from 'src/constants/AppStrings';
import {Platform, View} from 'react-native';
import RoundedAppButton, {
  RoundedAppButtonType,
} from 'src/components/elements/RoundedAppButton';
import {Dimensions} from 'react-native';
import {createMaterialTopTabNavigator} from '@react-navigation/material-top-tabs';
import AnnouncementScreen from 'src/components/screens/inbox/newui/AnnounceMentScreen';
import InboxScreen from 'src/components/screens/inbox/InboxScreen';
import {getTabOptions} from 'src/components/screens/inbox/newui/InboxScreenNewUI';
import AnnouncementEmpty from 'src/components/img/svg/inbox/Announcement';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';

const Tab = createMaterialTopTabNavigator();
const width = Dimensions.get('window').width;

export function dealDescDescriptor(props: DealDescriberData): JSX.Element {
  return (
    <AVText
      maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm12}
      style={props.styles.legalese}
      accessibilityLabel={props.deal.legalese}
    >
      {props.deal.legalese}
    </AVText>
  );
}
export function notificationTabscDescriptor(): JSX.Element {
  return (
    <>
      <Tab.Screen
        name={'Announcements'}
        component={AnnouncementScreen}
        options={getTabOptions(Localized.Labels.announcements)}
        initialParams={null}
      />
      <Tab.Screen
        name={'Messages'}
        component={InboxScreen}
        options={getTabOptions(Localized.Labels.messages)}
        initialParams={null}
      />
    </>
  );
}
export function getStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    expiration: {
      fontSize: Styles.Fonts.f0,
      marginBottom: Styles.Spacing.m3,
      marginTop: Styles.Spacing.m2,
      textAlign: 'center',
    },
    content: {
      flex: 1,
      padding: Styles.Spacing.m3,
    },
    topRow: {
      alignItems: 'center',
      flexDirection: 'row',
      marginBottom: Styles.Spacing.m3,
    },
  };
}

export function titleDescriptor(props?: DealDescriberData): string {
  return props.deal.promotionText;
}

export function dealIconDescriptor(size): JSX.Element {
  return (
    <DealDetailIcon
      width={size}
      height={size}
      bgColor={Styles.Colors.Aramark.primary}
    />
  );
}

export function announcemetEmptyIcon(): JSX.Element {
  return <AnnouncementEmpty stroke={Styles.Colors.Aramark.primary} />;
}

export function dealDefaultIconDescriptor(): JSX.Element {
  return dealIconDescriptor(Styles.Heights.h4);
}

export function dealAppliedBtn() {
  return (
    <RoundedButton
      buttonType={ButtonType.action}
      text={Localized.Labels.applied}
      color={'#707070'}
      containerStyle={getDealDetailStyleDescriptor().appliedButton}
      textStyle={getDealDetailStyleDescriptor().appliedButtonText}
      onPress={() => {
        return false;
      }}
    />
  );
}

export function dealApplyBtn(applyDeal: () => void) {
  return (
    <RoundedAppButton
      buttonType={RoundedAppButtonType.Solid}
      onPress={applyDeal}
      textStyle={{
        fontSize: Styles.Fonts.f1,
        textAlign: 'center',
        marginHorizontal: Styles.Spacing.m2,
      }}
      buttonContainerStyle={{
        bottom: Styles.Spacing.m3,
        marginHorizontal: Styles.Spacing.m3,
        alignSelf: 'flex-end',
      }}
      titleText={Localized.Buttons.apply}
    />
  );
}

export function dealAppliedContainer() {
  const fullText = Localized.Labels.offer_already_claimed;
  const [prefix, rest] = fullText.split(': ');
  return (
    <View style={getDealDetailStyleDescriptor().alreadyClaimedOffer}>
      <DealDetailIcon
        width={Styles.Spacing.m3 + 2}
        height={Styles.Spacing.m3 + 2}
        bgColor={Styles.Colors.Aramark.sky}
      />

      <AVText style={getDealDetailStyleDescriptor().alreadyClaimedOfferText}>
        <AVText
          style={[
            getDealDetailStyleDescriptor().alreadyClaimedOfferText,
            {fontWeight: '700'},
          ]}
        >
          {prefix + ': '}
        </AVText>
        {rest}
      </AVText>
    </View>
  );
}

export function dealValidityKey() {
  return Localized.Labels.ends_on;
}

export function backHeaderStyleDescriptor(): {
  [index: string]: number | string;
} {
  return {
    backgroundColor:
      Platform.OS === 'web' ? Styles.white : Styles.tabBarBackgroundColor,
  };
}

export function getDealEndDateTime(dealEndDateTime) {
  return (
    <AVText
      maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm12}
      accessibilityLabel={dealEndDateTime}
      style={getDealDetailStyleDescriptor().expiration}
    >
      {dealEndDateTime}
    </AVText>
  );
}

export function getDealDetailStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    topView: {
      marginTop: Styles.Spacing.m3,
    },
    image: {
      width: width / 2.4,
      height: width / 2.4,
      borderRadius: Styles.Spacing.m2,
    },
    iconView: {
      width: 50,
      height: 50,
      justifyContent: 'center',
      alignItems: 'center',
    },
    dealTitleRow: {
      alignItems: 'center',
      flexDirection: 'row',
      marginTop: Styles.Spacing.m2 + Styles.Spacing.m1,
    },
    redeemLimit: {
      marginTop: Styles.Spacing.m3,
      fontSize: Styles.Fonts.f0,
      fontWeight: '400',
      fontFamily: Styles.FontFamily.gothamRegular,
      alignSelf: 'center',
      color: Styles.Colors.PayNew.darkHuesBase04,
    },
    validUntil: {
      fontSize: getLayoutDescriber().bodyFontSize(),
      marginTop: Styles.Spacing.m3,
      fontWeight: '400',
      alignSelf: 'center',
      fontFamily: Styles.FontFamily.gothamRegular,
    },
    alreadyClaimedOffer: {
      marginTop: Styles.Spacing.m3,
      padding: Styles.Spacing.m3,
      flex: 1,
      flexDirection: 'row',
      borderRadius: Styles.Spacing.m2,
      backgroundColor: Styles.Colors.Aramark.toastBg,
    },
    alreadyClaimedOfferText: {
      fontSize: Styles.Fonts.f0,
      alignSelf: 'center',
      flex: 1,
      marginLeft: Styles.Spacing.m2,
      textAlignVertical: 'center',
      fontFamily: Styles.FontFamily.gothamRegular,
    },
    description: {
      fontSize: getLayoutDescriber().bodyFontSize(),
      marginTop: Styles.Spacing.m3,
      fontWeight: '400',
      fontFamily: Styles.FontFamily.gothamRegular,
      color: Styles.Colors.Aramark.black01,
    },
    expiration: {
      fontSize: Styles.Fonts.f0,
      fontFamily: Styles.FontFamily.gothamRegular,
      color: Styles.Colors.Aramark.black01,
    },
    name: {
      color: Styles.black,
      fontWeight: '700',
      fontFamily: Styles.FontFamily.gothamRegular,
      flex: 1,
      fontSize: getLayoutDescriber().subHeaderFontSize(),
      justifyContent: 'center',
    },
    appliedButton: {
      alignItems: 'center',
      alignSelf: 'flex-end',
      padding: Styles.Heights.h1,
      paddingHorizontal: 8,
      paddingVertical: 8,
      justifyContent: 'center',
    },
    appliedButtonText: {
      color: Styles.white,
      fontSize: getLayoutDescriber().bodyFontSize(),
      fontWeight: '700',
      textAlign: 'center',
      marginLeft: Styles.Spacing.m1,
      fontFamily: Styles.FontFamily.gothamRegular,
    },
    content: {
      paddingVertical: Styles.Spacing.m3,
      paddingHorizontal: Styles.Spacing.m3 + Styles.Spacing.m2,
      flex: 1,
      backgroundColor:
        Platform.OS === 'web' ? Styles.white : Styles.tabBarBackgroundColor,
    },
    allReadText: {
      fontSize: getLayoutDescriber().bodyFontSize(),
      paddingTop: Styles.Spacing.m1,
      color: Styles.Colors.Aramark.primary,
      fontFamily: Styles.FontFamily.gothamRegular,
      fontWeight: '700',
    },
    emptyMessageText: {
      marginTop: Styles.Spacing.m2,
      fontSize: getLayoutDescriber().bodyLargeFontSize(),
      fontFamily: Styles.FontFamily.gothamRegular,
      fontWeight: '700',
      color: '#111',
    },
    promoCreditDesc: {
      fontSize: getLayoutDescriber().bodyFontSize(),
      marginTop: Styles.Spacing.m3,
      fontFamily: Styles.FontFamily.gothamRegular,
      color: Styles.Colors.Aramark.black01,
    },
  };
}
export function allReadTextBgColor(): {[index: string]: string} {
  return {
    backgroundColor: '#DBE7FB',
    color: Styles.tabBarTextColor,
    allReadTextUnderLine: Styles.Colors.Aramark.primary,
  };
}

export function dealAppliedBtnIcon() {
  return null;
}
export function notificationReadUnreadColor(): string {
  return Styles.footerTabActive;
}

export default {
  dealDescDescriptor,
  getStyleDescriptor,
  titleDescriptor,
  dealIconDescriptor,
  dealApplyBtn,
  dealValidityKey,
  dealAppliedBtn,
  dealAppliedBtnIcon,
  dealAppliedContainer,
  getDealDetailStyleDescriptor,
  backHeaderStyleDescriptor,
  getDealEndDateTime,
  notificationTabscDescriptor,
  announcemetEmptyIcon,
  dealDefaultIconDescriptor,
  notificationReadUnreadColor,
  allReadTextBgColor,
};
